module.exports = __webpack_public_path__ + "img/MasksOutlined.bd7137bf.svg";